import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellValue } from 'react-table';

import Table from 'components/Table';
import Tooltip from 'components/Tooltip';

interface AuditChanges {
  property: string;
  oldValue: string;
  newValue: string;
}
interface ViewData {
  date: any;
  description: string;
  auditChanges: Array<AuditChanges>;
}

interface IViewChangeModal {
  viewData: ViewData;
  onClose: () => void;
  isOpen: boolean;
}

const ViewChangeModal: React.FC<IViewChangeModal> = ({ isOpen, onClose, viewData }) => {
  const { t } = useTranslation(['common', 'companySettings']);

  const columns = useMemo(
    () => [
      {
        Header: t('common:property'),
        accessor: 'property',
        Cell: (data: CellValue) => {
          return (
            <Box>
              <Text fontWeight="semibold" color="primary.500">
                {data.row.original?.property}
              </Text>
            </Box>
          );
        },
      },
      {
        Header: t('common:oldValue'),
        accessor: 'oldValue',
        Cell: (data: CellValue) => {
          return (
            <Box maxWidth="200px">
              <Tooltip label={data.row.original?.oldValue} bg="black">
                <Text fontWeight="semibold" color="primary.500" textOverflow="ellipsis" overflow="hidden">
                  {data.row.original?.oldValue}
                </Text>
              </Tooltip>
            </Box>
          );
        },
      },
      {
        Header: t('common:newValue'),
        accessor: 'newValue',
        Cell: (data: CellValue) => {
          return (
            <Box maxWidth="200px">
              <Tooltip label={data.row.original?.newValue} bg="black">
                <Text fontWeight="semibold" color="primary.500" textOverflow="ellipsis" overflow="hidden">
                  {data.row.original?.newValue}
                </Text>
              </Tooltip>
            </Box>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={{ base: 'unset', md: '700px' }}>
        <ModalHeader paddingBottom="0px">
          <Text>
            {t('common:on')} {viewData?.date}
          </Text>
          <Text>{viewData?.description}</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody paddingTop="0px">
          <Table columns={columns} data={viewData?.auditChanges || []} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewChangeModal;
